import React, { useMemo } from 'react';

import useMergeProps from '../../../../hooks/useMergeProps';
import useTypedSelector from '../../../../hooks/useTypedSelector';
import { MatchStatuses } from '../../../../types/match';
import { useLineUpMainViewContext } from '../../contexts/LineUpMainViewContext';
import { useLineUpPlayerContext } from '../../contexts/LineUpPlayerContext';

import LineUpPlayerStats from './LineUpPlayerStats';
import makeLineUpPlayerStatsPropsSelector from './LineUpPlayerStats.selector';

type PropsType = {
  className?: string;
};

const LineUpPlayerStatsContainer = (ownProps: PropsType) => {
  const { matchId, matchStatus, filterId } = useLineUpMainViewContext();
  const { playerId } = useLineUpPlayerContext();

  const selectorProps = useMemo(() => ({ playerId, filterId, matchId }), [playerId, filterId, matchId]);
  const selector = useMemo(() => makeLineUpPlayerStatsPropsSelector(), []);
  const selectedProps = useTypedSelector((state) => selector(state, selectorProps));

  const otherProps = useMemo(() => ({ matchStatus }), [matchStatus]);

  const enhancedProps = useMergeProps({ selectedProps, ownProps, otherProps });

  const { value } = selectedProps;

  if (
    typeof value === 'number' &&
    (String(matchStatus).toLowerCase() === MatchStatuses.LIVE ||
      String(matchStatus).toLowerCase() === MatchStatuses.ENDED)
  ) {
    return <LineUpPlayerStats {...enhancedProps} />;
  }

  return null;
};

export default LineUpPlayerStatsContainer;
